<script lang="ts" setup>
import type { AccordionBlockSchema } from '~/types/storyblok/accordion-block'

const props = defineProps<{ blok: AccordionBlockSchema }>()
const route = useRoute()

const expanded = ref<boolean>(!!props.blok.id && props.blok.id === route.query.scrollTo)
function toggle() {
  expanded.value = !expanded.value
}
</script>

<template>
  <div v-editable="blok">
    <AccordionDefault
      :title="blok.title"
      :expanded="expanded"
      @accordion-toggle="toggle"
    >
      <component
        :is="c.component"
        v-for="c in blok.content"
        :key="c._uid"
        :blok="c"
        :story="c"
      />
    </AccordionDefault>
  </div>
</template>
